// A "complete" legal name has at least two whitespace-separated parts (first + last).
// Used to (1) gate admin signup so full_name captures a complete legal name, (2) gate
// the organizer-name edit, and (3) flag an incomplete organizer name before an FHA
// statement is generated (the attesting organizer must be named in full).
export function isCompleteName(name) {
  if (!name || typeof name !== 'string') return false;
  const parts = name.trim().split(/\s+/).filter(Boolean);
  return parts.length >= 2;
}
